<template>
    <div>
        <select id="modal-shop-select" name="modal-shop-select" class="form-control w-100" v-model="activeState">
            <option v-for="value in states" :value="value.id" >{{ value.name }}</option>
        </select>
        <div class="row p-3">
            <div v-for="dealer in activeContents" class=" col-12 pt-4">
                <div class="row border-bottom">
                    <div class="col-9 mb-3">
                        <h5 class="font-weight-bold u-color-main">{{ dealer.name }}</h5>
                        <div>{{ dealer.address }}</div>
                        <div>
                            <div class="w-25 d-inline-block" v-if="dealer.phone1">{{ dealer.phone1 }}</div>
                            <div class="w-25 d-inline-block" v-if="dealer.phone2">{{ dealer.phone2 }}</div>
                            <div class="w-25 d-inline-block" v-if="dealer.phone3">{{ dealer.phone3 }}</div>
                            <div class="w-25 d-inline-block" v-if="dealer.whatsapp">{{ dealer.whatsapp }} <small><i class="fab fa-whatsapp"></i></small></div>
                        </div>
                        <div v-if="dealer.email"><a v-bind:href="`mailto:${dealer.email}`">{{ dealer.email }}</a></div>
                        <div v-if="dealer.web"><a v-bind:href="dealer.web" rel="nofollow noopener noreferrer" target="_blank">{{ dealer.web }}</a></div>
                    </div>
                    <div class="col-3 text-center">
                        <a v-bind:href="dealer.url" target="_blank" class="btn o-custom-button-main btn-sm">
                            {{ 'messages.go_to_maps' | trans }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.getDealers();
            this.getStates();
        },
        data() {
            return {
                selected: "selected",
                activeState: [],
                dealers: [],
                states: [],
            }
        },
        computed: {
            activeContents(){

                let state = this.activeState;
                let result = [];

                if(state.length <= 0) {
                    return [];
                }
                this.dealers.forEach(function(element){
                    (element['state'] == state)
                        ? result.push(element)
                        : null;
                });
                return result;
            }
        },

        methods: {
            getDealers: function () {
                axios
                    .get(route('ajax.getDealers'))
                    .then(response => {
                        this.dealers = response.data;
                    });
            },
            getStates: function () {
                axios
                    .get(route('ajax.getStates'))
                    .then(response => {
                        this.states = response.data;
                    });
            },
        }
    }
</script>
